import { render, staticRenderFns } from "./PreviewDocModal.vue?vue&type=template&id=220c4977&"
import script from "./PreviewDocModal.vue?vue&type=script&lang=js&"
export * from "./PreviewDocModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports